import { useEffect, useState } from "react";
import { api, errorMessage } from "../lib/api";

export const TeamTodayStrip = ({ revision, onOpen }) => {
  const [rows, setRows] = useState([]);
  const [error, setError] = useState("");
  useEffect(() => { api.get("/team/stats", { params: { period: "today" } }).then(({ data }) => setRows(data.rows))
    .catch((e) => setError(errorMessage(e))); }, [revision]);
  return <section className="team-today" data-testid="team-today"><h2 className="section-label">SQUADRA OGGI</h2>
    {error && <p role="alert" className="form-error" data-testid="team-today-error">{error}</p>}
    {!error && !rows.some((row) => row.active) && <p className="venue-no-meetings" data-testid="team-today-empty">Nessun commerciale attivo.</p>}
    <div className="team-today-list">{rows.filter((row) => row.active).map((row) => {
      const tone = row.missing_outcomes > 0 || row.days_since_activity >= 2 ? "red"
        : row.calls + row.appointments > 0 ? "green" : "gold";
      return <button type="button" key={row.id} className={`team-today-person ${tone}`} onClick={() => onOpen(row.id)}
        data-testid={`team-today-${row.id}`}><span className="team-today-circle" data-testid={`team-today-color-${row.id}`}>
          {row.name.split(" ").map((part) => part[0]).slice(0, 2).join("")}</span>
        <strong>{row.name.split(" ")[0]}</strong><small data-testid={`team-today-counts-${row.id}`}>
          {row.calls} chiam. · {row.appointments} app.</small></button>;
    })}</div>
  </section>;
};